import type { StackProps } from '@chakra-ui/react';
import { Flex, HStack, Text, VStack } from '@chakra-ui/react';
import { Num } from '@ui/components/Num';
import { UsdValue } from '@ui/components/Num/UsdValue';
import { Token } from '@ui/config/token';
import { useTokenPrice } from '@ui/hooks/tokenPrice';
import React from 'react';

import { useH2SwapForm } from './components/H2SwapForm/useH2SwapForm';
import { useToTokenAmount } from './components/H2SwapForm/useToTokenAmount';
import { useH2SwapDialog, useH2SwapToTokenInfo } from './useH2SwapDialog';

interface H2MinReceiveProps extends StackProps {
  title?: string;
}

export const H2MinReceive = ({ ...props }: H2MinReceiveProps) => {
  const toTokenInfo = useH2SwapToTokenInfo();
  const bondingAddress = useH2SwapDialog((s) => s.bondingTokenAddress);
  const toToken = useH2SwapForm((s) => s.toToken);
  const toTokenPrice = useTokenPrice({
    token:
      toToken === Token.Agent
        ? { type: Token.Bonding, bondingAddress }
        : toToken,
  }).data?.usd_price;
  const toTokenAmount = useToTokenAmount(undefined, true);

  return (
    <Flex justify="stretch" {...props}>
      <Text textStyle="body2" mr="auto">
        Min. token received (est.)
      </Text>
      <VStack gap={0} align="flex-end">
        <HStack gap="4px">
          <Num
            decimalPlaces={6}
            value={toTokenAmount}
            textStyle="body2Bold"
            lineClamp={1}
            wordBreak="break-all"
          />
          {toTokenInfo?.Icon && <toTokenInfo.Icon boxSize="16px" />}
        </HStack>
        <UsdValue
          prefix="~ $"
          value={toTokenAmount}
          price={toTokenPrice}
          textStyle="body3"
        />
      </VStack>
    </Flex>
  );
};
